import { Button, Col, Form, Input, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getBankDetailsByUserId, loadSingleStaff, postBankDetails, updateBankDetails } from '../../../redux/rtk/features/user/userSlice';
import getCompanyIdFromToken from '../../../utils/getCompanyIdFromToken';
import getUserFromToken from '../../../utils/getUserFromToken';
import BtnEditSvg from '../Button/btnEditSvg';


const BankDetailPopup = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const companyId = getCompanyIdFromToken();
  const userId = getUserFromToken();
  const navigate = useNavigate();
   const { id: user_id } = useParams();
  console.log("bankData", data, data.length)
const { id } = useParams();

  // useEffect(() => {
  //   if (data) {
  //     form.setFieldsValue({
  //       accountHolderName: data.accountHolderName || '',
  //       bankName: data.bankName || '',
  //       accountNumber: data.accountNumber || '',
  //       shortCode: data.shortCode || '',
  //       branchName: data.branchName || ''
  //     });
  //   }
  // }, [data, form]);
  // console.log("data", data);
  useEffect(() => {

    if (data && typeof data === 'object') {
      form.setFieldsValue({
        accountHolderName: data.accountHolderName || '',
        bankName: data.bankName || '',
        accountNumber: data.accountNumber || '',
        shortCode: data.shortCode || '',
        branchName: data.branchName || ''
      });
    }
  }, [data, form]);

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userId: parseInt(user_id),
      company_id: parseInt(companyId)
    };
  
    if (data && data.id) {
      console.log('ID being sent:', data.id);
      await dispatch(updateBankDetails({ id: data.id, values: payload }));
      dispatch(getBankDetailsByUserId(user_id));
      dispatch(loadSingleStaff(user_id))
      setIsModalOpen(false);

    } else {
      console.warn('ID is undefined or data is empty. Posting new data.');
      await dispatch(postBankDetails(payload));
      dispatch(getBankDetailsByUserId(user_id));
      dispatch(loadSingleStaff(user_id))

      setIsModalOpen(false);
    }
  };
  



  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        width="50%"
        title="Update Bank Details"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Account Holder Name"
                name="accountHolderName"
                rules={[{ required: true, message: 'Please input the account holder name!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Bank Name"
                name="bankName"
                // rules={[{ required: true, message: 'Please input the bank name!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Account Number"
                name="accountNumber"
                rules={[{ required: true, message: 'Please input the account number!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Short Code"
                name="shortCode"
                rules={[{ required: true, message: 'Please input the short code!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Branch Name"
            name="branchName"
            // rules={[{ required: true, message: 'Please input the branch name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Bank Details
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default BankDetailPopup;
